import type { SgwtMiniFooterHTMLElement } from '@sgwt/sgwt-widgets-react';
import { useEffect, useState } from 'react';
export function useHasQumuConsent() {
  const [hasConsented, setHasConsented] = useState<boolean>(false);

  useEffect(() => {
    const miniFooter = document.querySelector<SgwtMiniFooterHTMLElement>('sgwt-mini-footer');
    if (!miniFooter || typeof miniFooter.getUserConsentOnQumu !== 'function') {
      return;
    }
    miniFooter.getUserConsentOnQumu().then(value => {
      setHasConsented(value);
    });
  }, []);

  return hasConsented;
}
